import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Input, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import * as Highcharts from 'highcharts';
import * as _ from 'lodash';
import { PiechartService } from '../../piechart.service';
import { Observable, Subscription } from 'rxjs';
import { COMMON_CONSTANTS, COMMON_CONSTANTS_Percentage, COMMON_CONSTANTS_SNAPSHOT } from 'src/app/common/constants/common-constants';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SignificanceService } from 'src/app/common/services/significance.service';

@Component({
  selector: 'app-piechart15-custom',
  templateUrl: './piechart15.component.html',
  styleUrls: []
})
export class Piechart15ComponentCustom implements OnChanges {
  _resizeListenerSet = false;
  //private _configService: any;
  
  constructor(
    private http: HttpClient,
    private piechartservice: PiechartService,
    private _configService: SnapshotService,
    private _customSnapshotService: CustomsnapshotService,
    private route: ActivatedRoute,
    private significanceService: SignificanceService,
  ) {}

  jsondata: any;
  seriescolor: any;
  samplesizeconstant:any;
  chartproperties: any; 
  seriesgradientcolor:any;
  chartimagepath:any
  userselectedchartdata: any;
  ChartProperties: any;

  @Input() gridTempleteColumns: any;
  @Input() popUpp: any;
  @Input() popUp: any;
  @Input() customData: any;
  @Input() id: any = 0;
  @Input() sort: any;
  @Input() WidgetDetails: any;
  @Input() height: any = "24em";
  @Input() isOutput: any;

  maxDataPoints: any = 2;
  significanceValue: any = "None";
  chartMainData: any = [];
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  DefaultConfidenceLevel: any = "";
 
  private subscriptions: Subscription = new Subscription();
  configuredProperties: any;
  
  ngOnChanges(changes: SimpleChanges): void {
    // Force chart reflow when popup state changes
    if (changes['popUp'] && this.chart) {
      setTimeout(() => {
        this.chart.reflow();
        this.getResponsiveChartProps(); // Update center position dynamically
        // Re-render chart with updated popup configuration if needed
        // this.plotChart('chart-container'+this.id, this.jsondata?.data || this.customData, this.chartproperties);
      }, 150);
    }

    if (changes['customData'] && !changes['customData'].firstChange) {
      if (this.isOutput) {
        this.configuredProperties = JSON.parse(this.customData.customizationProperties);
        this.customData = this.customData.metric[0];
        this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
        this.updateSig();
      }
    }
  }
  
  ngOnInit(): void {
    if(this.isOutput){
      this.configuredProperties = JSON.parse(this.customData.customizationProperties);
      this.customData = this.customData.metric[0];
      this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
      this.maxDataPoints = this.popUp ? 6 : this.maxDataPoints;
      this.subscriptions.add(
        this._configService.confedenceValue.subscribe((value: any) => {
          this.DefaultConfidenceLevel = value;
          this.updateSig();
        }));
      this.subscriptions.add(
        this._configService.significanceValue.subscribe((value: any) => {
          this.significanceValue = value;
          this.updateSig();
        }));     
    }else{
      this.http.get<any>('assets/Data/piechart.json').subscribe((data) => {
        this.jsondata = data[0];
        this.chartproperties = this.jsondata['properties'][0];
        this.chartproperties.decimalRoundOff=0;
        // Assign datalabelsize initially as datalabelsize - 0.2
      
          this.chartproperties.dataLabelSize = '0.8em';
        
        this.seriescolor = this.piechartservice.color.slice(0,10).reverse();
        this.seriesgradientcolor=this.piechartservice.linearGradients1;
        this.samplesizeconstant=this.piechartservice.samplesizeconstant;
        this.chartimagepath=this.piechartservice.chartimagepath;
        this.route.paramMap.subscribe((params) => {
          const userData = history.state.userData;
          this.userselectedchartdata = userData; // Use the userData object as needed
          if (this.userselectedchartdata?.widgetEditSelection) {
            if (this.userselectedchartdata?.widgetEditSelection?.customizationProperties != "") {
              this.chartproperties = JSON.parse(this.userselectedchartdata?.widgetEditSelection?.customizationProperties);
            }
          }
        });
        this.plotChart('chart-container'+this.id, this.jsondata['data'], this.chartproperties);
      });
    }
  }

  updateSig() {
    this.updateSigSub?.unsubscribe();
    this.updateSigSub = this.http.get<any>('assets/Data/piechart.json').subscribe((data) => {
        this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
        this.jsondata = data[0];
        this.chartproperties = this.jsondata['properties'][0];
        this.chartproperties = this.configuredProperties != undefined ? this.configuredProperties : this.chartproperties;
        // Assign datalabelsize initially as datalabelsize - 0.2
        this.chartproperties.dataLabelSize = '0.8em';
        this.seriescolor = this.piechartservice.color;
        this.seriesgradientcolor = this.piechartservice.linearGradients1;
        this.samplesizeconstant = this.piechartservice.samplesizeconstant;
        this.chartproperties.datalabelStyle = this.significanceValue == "None" ? "datalabel" : "sigChange";
        this.chartproperties.dataLabelPosition = 'left';
        this.chartproperties.datalabelStyle = this._configService.isIndexSelected ? "index" : this.chartproperties.datalabelStyle;
        this.Sig_LowerLimt = this.significanceService.getSigLowerLimit(this.DefaultConfidenceLevel, true);
        this.Sig_UpperLimt = this.significanceService.getSigUpperLimit(this.DefaultConfidenceLevel, true);
        this.plotChart(
          'chart-container'+this.id,
          this.jsondata['data'],
          this.chartproperties
        );
      });
  }

  customization(): Observable<any> {
    //return this.piechartservice.PieChart1to10customizationList();
      const snapshotTypeSelectedName = this._customSnapshotService.selectedSnapshotType?.name;
    const cohortType = snapshotTypeSelectedName && snapshotTypeSelectedName.toLowerCase().includes('audience') 
      ? this._configService.audienceCohortType 
      : 'NA';
    return _.cloneDeep(this._customSnapshotService.getChartCustomization("05/Pie Chart", snapshotTypeSelectedName, cohortType));
  }

  applycustomization(event: any, item: string) {
    //choose the appropriate customization
    this.piechartservice.applycustomization(event,item, this.chartproperties)
    this.plotChart('chart-container'+this.id,this.jsondata['data'],this.chartproperties);
    }

  seriesdata: any;
  cov: any;
  significance: any;
  samplesize:any;
  label: any;
  datalength:number=10;
  preparechartdata(data: any,islowsample:boolean,isgradient:boolean,isdarktheme:boolean) {

    const chartElement = document.getElementById('chart-container'+this.id);  // Replace with your chart's container
    const chartWidth = chartElement?.offsetWidth || 0; // Get width of chart container
    const chartHeight = chartElement?.offsetHeight || 0; 

    const widthFactor = chartWidth / 1050; // Example: scale based on the width of the chart
    const heightFactor = chartHeight / 850;
    if (this.isOutput) {
      let seriesdata: any[] = [];
      let cov: any = [];
      let significance: any = [];
      let samplesize: any = [];
      let label: any = [];
      let i = 0;
      // let innerSize = 40;
      // let size = 27;

      // Dynamic calculation based on container size and number of rings
      const numRings = data.length;
      const containerSize = Math.min(chartWidth, chartHeight);
      // Reduce chart size in popup mode
      const availableRadius = this.popUp ? 
        (containerSize * 0.6) / 2 :  // Smaller size for popup (40% instead of 90%)
        (containerSize * 0.8) / 2;   // Normal size for regular view
      
      // Calculate ring width and gap - gap should be 60% of ring width
      // Total space = (ringWidth + gap) * numRings
      // gap = ringWidth * 0.6
      // So: Total space = (ringWidth + ringWidth * 0.6) * numRings = ringWidth * 1.6 * numRings
      const totalRingArea = availableRadius * 0.8;
      const actualRingThickness = totalRingArea / (numRings * 1.6); // Account for ring + 60% gap
      const gapWidth = actualRingThickness * 0.6; // Gap is 60% of ring width
      
      // Start with a base inner radius and calculate each ring position
      let currentInnerRadius = availableRadius * 0.2; // Start from 20% of available radius
      let innerSize = currentInnerRadius;
      let size = currentInnerRadius + actualRingThickness;
      
      let baseInnerSize = 35;  // Base inner size for the first ring
      let baseSize = 20;  // Base outer size for the first ringcls
      let ringGap = gapWidth; // Gap is exactly 60% of ring width
      let d: any = {};
      d.animation = this.piechartservice.allowAnimation;
      d.data = [];
      let count = 0;
      // d.innerSize = innerSize;
      // d.size = size;
      data.forEach((dat: any) => {

        cov.push(dat['Change value vs PY']);
        significance.push(dat['Significance']);
        label.push(dat['Label']);
        samplesize.push(dat['Sample size'])
        let value = isNaN(parseFloat(dat['Value'])) || parseFloat(dat['Value']) == null ? null : parseFloat(Number(dat['Value']).toFixed(this.chartproperties.decimalRoundOff));
        let finalvalue = !islowsample ? value : (parseFloat(dat['Sample size']) > this.samplesizeconstant ? value : 0)
        // d.innerSize = innerSize + (innerSize * widthFactor); // Adjust innerSize dynamically based on chart width
        // d.size = size + ( size*heightFactor);

        // d.innerSize = innerSize + ( ringGap*count ); // Adjust innerSize dynamically based on chart width
        // d.size = size + ( ringGap*count );
        
        // const bigScreen = window.innerWidth >= 1600;
        d.innerSize = (innerSize + (ringGap * count)) * ((this.popUp || this.height === '100%' ) ? 2.2 : 1.65); // Reduced popup multiplier from 3.2 to 2.2
        d.size = (size + (ringGap * count)) * ((this.popUp || this.height === '100%' ) ? 2.2 : 1.65); // Reduced popup multiplier from 3.2 to 2.2
       

        d.animation=this.piechartservice.allowAnimation;
        let m =[ {
          name: dat['Series Name'],
          y: (this._configService.userRole != "superadmin" && Number(dat['Sample size']) <= this._configService.ISthreshold ? 0 : (finalvalue == null ? 0 : finalvalue)),
          indexValue: (this._configService.userRole != "superadmin" && Number(dat['Sample size']) <= this._configService.ISthreshold ? 0 : (dat['ValueForIndex'] == null ? 0 : dat['ValueForIndex'])),
          actualIndexValue: dat['ActualIndexValue'],
          y1: this._configService.isIndexSelected ? finalvalue : (this._configService.userRole != "superadmin" && Number(dat['Sample size']) <= this._configService.ISthreshold ? 0 : (finalvalue == null ? 0 : finalvalue)),
          // legendkeycolor: this.seriescolor[i],
          // actualcolor: this.seriescolor[i],
          // color: !isgradient ? this.seriescolor[i++] : this.seriesgradientcolor[i++],
          legendkeycolor: dat['color']
          ? dat['color']
          : (!isgradient ? this.seriescolor[i] : this.seriesgradientcolor[i]),

        actualcolor: dat['color']
          ? dat['color']
          : (!isgradient ? this.seriescolor[i] : this.seriesgradientcolor[i]),

        color: dat['color']
          ? dat['color']
          : (!isgradient ? this.seriescolor[i++] : this.seriesgradientcolor[i++]),

          cov: dat['Change value vs PY'],
          significance: dat['Significance'],
          significance2: dat['Significance2'],
          samplesize: dat['Sample size'],
          tooltip: "",
          isPercentage: dat["isPercentage"],
          Sig_LowerLimt: this.Sig_LowerLimt,
          Sig_UpperLimt: this.Sig_UpperLimt,
          Significance_Value: dat["Significance_Value"]
        },
        {
          name: 'other',
          y: 100 - (value==null?0:value),
          color: !isdarktheme?'#eeebed':'#7f7f7f',
          legendkeycolor:!isdarktheme?'#eeebed':'#7f7f7f',
        }]
        // d.data.push(m);
        // //d.data = m;
        // seriesdata.push(d);
        // d = {};
        // innerSize += 30;
        // size += 20;
        this.datalength++;
        d.data = m;
        seriesdata.push(d);
        d = {};
        // innerSize = innerSize + (innerSize* widthFactor); // Dynamically adjust innerSize
        // size = size + (size* heightFactor); 
        
        // Move to next ring position: current outer radius + gap
        currentInnerRadius = size + gapWidth;
        innerSize = currentInnerRadius;
        size = currentInnerRadius + actualRingThickness;

        // d.innerSize = baseInnerSize + ringGap * count;  // Inner size of the ring
        // d.size = baseSize + ringGap * count;
        count++;  // Outer size of the ring
      });
      // seriesdata = [d];
      // d = {};
      this.cov = cov;
      this.significance = significance;
      this.label = label;
      this.samplesize = samplesize;
      this.seriesdata = seriesdata;

    }
    else{
  let seriesdata: any[] = [];
  let d: any = {};
  let cov: any = [];
  let significance: any = [];
  let samplesize:any=[];
  let label: any = [];
  let i = 0;
      let innerSize = 35;
      let size = 25;
      data.forEach((dat: any) => {
        if(i<this.datalength){
        cov.push(dat['Change value vs PY']);
        significance.push(dat['Significance']);
        label.push(dat['Label']);
        samplesize.push(dat['Sample size'])
  d.innerSize = innerSize + (innerSize * widthFactor); // Adjust innerSize dynamically based on chart width
  d.size = size + ( size*heightFactor);
        d.animation=this.piechartservice.allowAnimation;
        let value=isNaN(parseFloat(dat['Value']))||parseFloat(dat['Value'])==null?null:parseFloat(Number(dat['Value']).toFixed(this.chartproperties.decimalRoundOff));
        let finalvalue=!islowsample?value:(parseFloat(dat['Sample size'])>this.samplesizeconstant?value:0)
        let m = [
          {
            name: dat['Series Name'],
            y: finalvalue==null?0:finalvalue,
            y1:finalvalue,
            legendkeycolor: this.seriescolor[i],
            actualcolor:this.seriescolor[i],
            color: !isgradient?this.seriescolor[i++]:this.seriesgradientcolor[i++],
            cov:dat['Change value vs PY'],
            significance:dat['Significance'],
            significance2:dat['Significance2'],
            samplesize:dat['Sample size'],
            tooltip:""
          },
          {
            name: 'other',
            y: 100 - (value==null?0:value),
            color: !isdarktheme?'#eeebed':'#7f7f7f',
            legendkeycolor:!isdarktheme?'#eeebed':'#7f7f7f',
          },
        ];
        d.data = m;
        seriesdata.push(d);
        d = {};
  innerSize = innerSize + (innerSize* widthFactor); // Dynamically adjust innerSize
  size = size + (size* heightFactor); 
        // this.datalength++;
      }
      });
      this.cov = cov;
      this.significance = significance;
      this.label = label;
      this.samplesize=samplesize;
      this.seriesdata = seriesdata;
    }
    
  }

  chart: any;
  
  // private getDynamicCenter(): [string, string | number] {
  //   // Get the container element to calculate dynamic center
  //   const containerElement = document.getElementById('chart-container' + this.id);
  //   if (containerElement) {
  //     const containerHeight = containerElement.offsetHeight;
  //     if (this.popUp) {
  //       // For popup, center at 50% of container height
  //       return ['50%', '50%'];
  //     } else {
  //       // For normal view, center at 40% of container height
  //       return ['50%', containerHeight * 0.35]; // 20% of container height
  //     }
  //   }
  //   // Fallback to percentage-based centering
  //   return this.popUp ? ['50%', '50%'] : ['50%', '20%'];
  // }

  // private updateChartCenter(): void {
  //   if (this.chart && this.chart.series && this.chart.series.length > 0) {
  //     const newCenter = this.getDynamicCenter();
  //     this.chart.series.forEach((series: any) => {
  //       if (series.type === 'pie') {
  //         series.update({
  //           center: newCenter
  //         }, false);
  //       }
  //     });
  //     this.chart.redraw();
  //   }
  // }
  private getResponsiveChartProps(): {
  center: [string, string | number],
  size: string,
  innerSize: string,
  fontSize: string,
 
  connectorWidth: number
} {
  const containerElement = document.getElementById('chart-container' + this.id);

  // If popup is true, use fixed properties
  if (this.popUp && !this.chartproperties?.showLegend) {
    return {
      center: ['50%', '50%'],
      size: '90%',
      innerSize: '40%',
      fontSize: '0.9rem',
     
      connectorWidth: 2
    };
  }

  if (!containerElement) {
    return { 
      center: ['50%', '40%'], 
      size: '75%', 
      innerSize: '45%',
      fontSize: '0.8rem',
   
      connectorWidth: 1
    };
  }

  const containerWidth = containerElement.offsetWidth;
  const containerHeight = containerElement.offsetHeight;
  const minDimension = Math.min(containerWidth, containerHeight);
  const dataLength = this.isOutput ? 
    (this.chartMainData?.length || 0) : 
    (this.jsondata?.data?.length || 0);
  const isSingleElement = dataLength === 1;
  
  // Calculate dynamic Y position based on container height and legend position
  const calculateYPosition = () => {
    const heightRatio = containerHeight / 400; // Base ratio for 400px height
    const baseYPercent = this.chartproperties?.legendPosition === 'bottom' ? 35 : 38;
    
    if (this.popUp) {
      // For popup, center more towards middle regardless of legend position
      return this.chartproperties?.legendPosition === 'bottom' ? '40%' : '50%';
    } else {
      // Adjust Y position based on container height
      let adjustedY = baseYPercent;
       if (containerHeight < 200) {
        // Very short containers - move chart higher
        adjustedY = this.chartproperties?.legendPosition === 'bottom' ? 25 : 18;
      } else if (containerHeight > 500) {
        // Taller containers - can afford to move chart down slightly
        adjustedY = this.chartproperties?.legendPosition === 'bottom' ? 40 : 40;
      }
      
     else if (containerHeight < 300) {
        // Very short containers - move chart higher
        adjustedY = this.chartproperties?.legendPosition === 'bottom' ? 25 : 25;
      } else if (containerHeight > 500) {
        // Taller containers - can afford to move chart down slightly
        adjustedY = this.chartproperties?.legendPosition === 'bottom' ? 40 : 40;
      }
      
      return adjustedY + '%';
    }
  };
  
   if (minDimension < 200) {
    return {
      center: [
        this.chartproperties?.legendPosition === 'left' ? '80%' : (this.chartproperties?.legendPosition === 'right' ? '20%' : this.chartproperties?.legendPosition === 'bottom' ? this.popUp?'50%' : '70%':'50%'),
        calculateYPosition()
      ],
      size: this.chartproperties?.showLegend ? !this.popUp?this.chartproperties?.legendPosition === 'bottom' ? '25%' : '75%' : '75%':'75%',
      innerSize: this.popUp?'90%':isSingleElement?'50%':'35%',
      fontSize: '0.7rem',
   
      connectorWidth: 1
    };
  }
  
  // 📱 Mobile/Small screens (< 400px)
  if (minDimension < 400) {
    return {
      center: [
        this.chartproperties?.legendPosition === 'left' ? '80%' : (this.chartproperties?.legendPosition === 'right' ? '30%' : this.chartproperties?.legendPosition === 'bottom' ? this.popUp?'50%' : '70%':'50%'),
        calculateYPosition()
      ],
      size: this.chartproperties?.showLegend ? !this.popUp?this.chartproperties?.legendPosition === 'bottom' ? '25%' : '75%' : '75%':'75%',
      innerSize: this.popUp?'90%':isSingleElement?'50%':'35%',
      fontSize: '0.7rem',
   
      connectorWidth: 1
    };
  }
  
  // 📱 Tablet/Medium screens (400-800px)
  if (minDimension < 800) {
    // Calculate Y position for medium screens
    const mediumYPosition = () => {
      if (this.popUp) {
        return this.chartproperties?.legendPosition === 'bottom' ? '45%' : '50%';
      } else {
        // Adjust based on container height for medium screens
        let baseY = this.chartproperties?.legendPosition === 'bottom' ? 25 : 48;
        
        if (containerHeight < 350) {
          baseY = this.chartproperties?.legendPosition === 'bottom' ? 20 : 35;
        } else if (containerHeight > 600) {
          baseY = this.chartproperties?.legendPosition === 'bottom' ? 35 : 55;
        }
        
        return baseY + '%';
      }
    };
    
    return {
      center: [
        this.chartproperties?.legendPosition === 'left' ? this.popUp?'65%':'75%' : (this.chartproperties?.legendPosition === 'right' ? this.popUp?'35%':'30%' : '50%'),
        mediumYPosition()
      ],
      size: this.popUp?'80%':this.chartproperties?.showLegend ? this.chartproperties?.legendPosition === 'bottom' ? '45%' : '55%' : '75%',
      innerSize: '42%',
      fontSize: '0.8rem',
    
      connectorWidth: 1
    };
  }

  // 🖥️ Desktop/Large screens (800px+)
  // Calculate Y position for desktop screens
  const desktopYPosition = () => {
    let baseY = this.chartproperties?.legendPosition === 'bottom' ? 40 : 40;
    
    // Adjust based on container height for desktop screens
    if (containerHeight < 400) {
      baseY = this.chartproperties?.legendPosition === 'bottom' ? 30 : 35;
    } else if (containerHeight > 700) {
      baseY = this.chartproperties?.legendPosition === 'bottom' ? 45 : 45;
    }
    
    return baseY + '%';
  };
  
  return {
    center: [
      this.chartproperties?.legendPosition === 'left' ? '60%' : (this.chartproperties?.legendPosition === 'right' ? '35%' : '50%'),
      desktopYPosition()
    ],
    size: this.chartproperties?.showLegend ? this.chartproperties?.legendPosition === 'bottom' ? '50%' : '55%' : '65%',
    innerSize: '45%',
    fontSize: '0.9rem',
  
    connectorWidth: 2
  };
}
private getLegendMaxHeight(): number {
  const container = document.getElementById('chart-container' + this.id);
  if (container && container.offsetHeight) {
    return Math.floor(container.offsetHeight * 0.90);
  }
  // Fallback value if container not found
  return 300;
}
private getLegendYPosition(): number {
  const container = document.getElementById('chart-container' + this.id);
  if (!container) return 0;

  // Get the chart area inside the container
  const chartCanvas = container.querySelector('svg, canvas, .highcharts-container') as HTMLElement;

  if (chartCanvas) {
    // Bounding box of the chart area relative to the container
    const chartRect = chartCanvas.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();

    // Calculate top offset relative to the container itself
    const relativeTop = chartRect.top - containerRect.top;

    // Add a small margin if needed
    const margin = 0;
    return Math.max(relativeTop + margin, 0);
  }

  // Fallback: top of the container
  return 0;
}



 private getLegendXPosition(chartproperties: any, popUp: boolean): number {
  const containerElement = document.getElementById('chart-container' + this.id);
  let minDimension = 800; // default for desktop
  if (containerElement) {
    const containerWidth = containerElement.offsetWidth;
    const containerHeight = containerElement.offsetHeight;
    minDimension = Math.min(containerWidth, containerHeight);
  }

  // Responsive logic based on minDimension
  if (popUp) {
    if (minDimension < 400) {
      if (chartproperties.legendPosition === 'right') return 0;
      if (chartproperties.legendPosition === 'left') return 5;
      return 0;
    }
    if (minDimension < 500) {
      if (chartproperties.legendPosition === 'right') return 5;
      if (chartproperties.legendPosition === 'left') return 40;
      return 0;
    }
    if (chartproperties.legendPosition === 'right') return 10;
    if (chartproperties.legendPosition === 'left') return 15;
    return 0;
  } else {
    if (minDimension < 220) {
           if (chartproperties.legendPosition === 'right') return 80;
      if (chartproperties.legendPosition === 'left') return 120;
      return 10;
  
    }
     if (minDimension < 240) {
           if (chartproperties.legendPosition === 'right') return 90;
      if (chartproperties.legendPosition === 'left') return -10;
      return 10;
  
    }
     if (minDimension < 280) {
           if (chartproperties.legendPosition === 'right') return 30;
      if (chartproperties.legendPosition === 'left') return -10;
      return 10;
  
    }
    
    if (minDimension < 400) {
     if (chartproperties.legendPosition === 'right') return 60;
      if (chartproperties.legendPosition === 'left') return 120;
      return 10;
    }
    if (minDimension < 500) {
      if (chartproperties.legendPosition === 'right') return 80;
      if (chartproperties.legendPosition === 'left') return -10;
      return 15;
    }
    if (minDimension < 800) {
      if (chartproperties.legendPosition === 'right') return 20;
      if (chartproperties.legendPosition === 'left') return 150;
      return 20;
    }
    // Desktop/Large screens
    if (chartproperties.legendPosition === 'right') return 120;
    if (chartproperties.legendPosition === 'left') return -10;
    return 20;
  }
}
// private getLegendXPosition(chartproperties: any, popUp: boolean): number {
//   const container = document.getElementById('chart-container' + this.id);
//   if (!container) return 0;

//   // Get the bounding rectangle of the container
//   const rect = container.getBoundingClientRect();
//   // Chart width (excluding legend)
//   const chartWidth = container.offsetWidth;

//   // Estimate the pie chart's rendered width (centered, but not full width)
//   // You can tweak the multiplier (e.g., 0.65) based on your chart's size ratio
//   const pieChartWidth = chartWidth * 0.65;

//   // The legend should start just after the pie chart's right edge
//   // So, legendX = left of container + pieChartWidth + margin - left of container = pieChartWidth + margin
//   const margin = 20; // px, adjust as needed

//   // Only apply this logic for right legend
//   if (chartproperties.legendPosition === 'right') {
//     return Math.round(pieChartWidth + margin);
//   }
//   // For left or bottom, use your existing logic or return 0
//   if (chartproperties.legendPosition === 'left') {
//     return 10;
//   }
//   return 0;
// }
  private getLegendItemWidth(chartproperties: any, popUp: boolean): number {
  const containerElement = document.getElementById('chart-container' + this.id);
  let minDimension = 800; // default for desktop
  if (containerElement) {
    const containerWidth = containerElement.offsetWidth;
    const containerHeight = containerElement.offsetHeight;
    minDimension = Math.min(containerWidth, containerHeight);
  }

  // Responsive logic based on minDimension
  if (popUp) {
    if (minDimension < 400) {
      return 180;
    }
    if (minDimension < 500) {
      return 420;
    }
    return 520;
  } else {
    if (minDimension < 400) {
      if (chartproperties.legendPosition === 'bottom') return 120;
      if (chartproperties.legendPosition === 'left') return 200;
      return 250;
    }
    if (minDimension < 500) {
      if (chartproperties.legendPosition === 'bottom') return 160;
      if (chartproperties.legendPosition === 'left') return 180;
      return 100;
    }
    if (minDimension < 800) {
      if (chartproperties.legendPosition === 'bottom') return 200;
      if (chartproperties.legendPosition === 'left') return 220;
      return 400;
    }
    // Desktop/Large screens
    if (chartproperties.legendPosition === 'bottom') return 200;
    if (chartproperties.legendPosition === 'left') return 220;
    return 250;
  }
}
  plotChart(containerId: any, jsondata: any,chartproperties:any) {
    // Responsive legend position logic
     const componentId = this.id;
           const componentRef = this; // Capture component reference for insights state
         const getLegendItemWidth = this.getLegendItemWidth.bind(this);
    let legendX = 0;
    let legendY = chartproperties.legendPosition === 'bottom' ? -10 : 1;
    // Always keep a small gap (30px) between chart and legend
    if (chartproperties.legendPosition === 'right') {
      legendX = -60;
    } else if (chartproperties.legendPosition === 'left') {
      legendX = -20;
    }

    // Re-plot chart on window resize for responsiveness
    if (!this._resizeListenerSet) {
      window.addEventListener('resize', () => {
        this.plotChart(containerId, jsondata, chartproperties);
      });
      this._resizeListenerSet = true;
    }
  
    if (this.isOutput) {
        const containerElement = document.getElementById(containerId);
  if (containerElement && chartproperties.legendPosition === 'right') {
    containerElement.classList.add('piechart15-legend-right');
  } else if (containerElement) {
    containerElement.classList.remove('piechart15-legend-right');
  }
      localStorage.setItem("properties", JSON.stringify(this.chartproperties));
      let height = this.height;
      let samplesizeconstant = this.samplesizeconstant;
      let chartimagepath = this.chartimagepath;
      this.preparemainChartData(this.customData);
      this.preparechartdata(this.chartMainData, chartproperties.datalabelStyle == 'ls', chartproperties.gradientBarColor, false);
      const configService = this._configService;
      const popUpState = this.popUp;
      const bigScreen = window.innerWidth >= 1600;

      const containerEl = document.getElementById(containerId);
      if (!containerEl) { return; }
      this.chart = Highcharts.chart(containerEl, {
        accessibility: {
          point: {
            valueSuffix: '%'
          }
        },
        chart: {        
          type: 'pie',
           spacingBottom: this.popUp?chartproperties.showLegend && chartproperties.legendPosition == "bottom" ? 10 : 0:0,

          marginBottom: this.popUp?chartproperties.showLegend && chartproperties.legendPosition == "bottom" ? 10 : 10:0, // Slightly more margin for cleaner separation
          marginRight: chartproperties.legendPosition == "right" ? 0 : this.popUp?10:(chartproperties.legendPosition == "left" ? 60 : 5),
          marginLeft:this.popUp?5:chartproperties.legendPosition=="left"?40:5,
          reflow: true,
          height: this.popUp ? null : this.chartproperties.legendPosition=='bottom'?280:350, 
          backgroundColor: chartproperties.darkTheme ? '#333' : 'white',
          style: {
            fontFamily: this.piechartservice.fontFamily,
            width: '100%',
          },
          events: {
            load: function (this: Highcharts.Chart) {
              const chart = this;
              window.addEventListener('resize', () => {
                chart.redraw();
              });
    const legendClass = popUpState ? 'radial-pie-popup' : 'radial-pie';

// Add class to SVG legend group (for SVG styling, if needed)
if (this.legend && this.legend.group && this.legend.group.element) {
  this.legend.group.element.classList.add(legendClass);
}

// Add class to HTML legend container (for CSS targeting)
if (this.container) {
  // Legend container
  const htmlLegend = this.container.querySelector('.highcharts-legend');
  if (htmlLegend) {
    htmlLegend.classList.add(legendClass);
  }
  // Legend items
  const legendItems = this.container.querySelectorAll('.highcharts-legend-item');
  legendItems.forEach((item: Element) => {
    item.classList.add(legendClass);
  });
  // No-tooltip overlays
  const noTooltipEls = this.container.querySelectorAll('.highcharts-no-tooltip');
  noTooltipEls.forEach((el: Element) => {
    el.classList.add(legendClass);
  });
}
               const legend = this.legend && (this.legend as any).group;
  if (
    this.options.legend &&
    this.legend &&
    (this.legend.options.align === 'left' || this.legend.options.align === 'right')
  ) {
    // Use plotHeight and plotTop for accurate centering
    const plotTop = this.plotTop;
    const plotHeight = this.plotHeight;
    const legendBBox = legend.getBBox();
    const legendHeight = legendBBox.height;

    // Center legend in the plot area and move it up by 10px (adjust -10 as needed)
    const newY = plotTop + Math.max(0, Math.round((plotHeight - legendHeight) / 2)) - 10;
    legend.attr({ translateY: newY });
  }
            },
             render: function (this: Highcharts.Chart) {
              const chart = this as any;
   const isPopup = popUpState; // or use popUpState if that's your variable
const legendClass = isPopup ? 'radial-pie-popup' : 'radial-pie';

// Add class to SVG legend group (for SVG styling, if needed)
if (this.legend && this.legend.group && this.legend.group.element) {
  this.legend.group.element.classList.add(legendClass);
}

// Add class to HTML legend container (for CSS targeting)
if (this.container) {
  const htmlLegend = this.container.querySelector('.highcharts-legend');
  if (htmlLegend) {
    htmlLegend.classList.add(legendClass);
  }
  // For no-tooltip overlays
  const noTooltipEls = this.container.querySelectorAll('.highcharts-no-tooltip');
  noTooltipEls.forEach((el: Element) => {
    el.classList.add(legendClass);
  });
}
  const legend = this.legend && (this.legend as any).group;
  if (
    this.options.legend &&
    this.legend &&
    (this.legend.options.align === 'left' || this.legend.options.align === 'right')
  ) {
    // Use plotHeight and plotTop for accurate centering
    const plotTop = this.plotTop;
    const plotHeight = this.plotHeight;
    const legendBBox = legend.getBBox();
    const legendHeight = legendBBox.height;

    // Center legend in the plot area and move it up by 10px (adjust -10 as needed)
    const newY = plotTop + Math.max(0, Math.round((plotHeight - legendHeight) / 2)) - 100;
    legend.attr({ translateY: newY });
  }
}
          }

          // events:{
          //   render: function () {
          //     const chart = this as any;
            
          //     // Check if the image and circle already exist, and return without rendering if they do
          //     if (chart.groupImage && chart.dottedBorder) {
          //       // Update the position of existing elements if the chart position changes
          //       if (chart.groupImage.attr('x') !== chart.plotLeft + chart.plotWidth / 2 - 50 / 2 ||
          //           chart.groupImage.attr('y') !== chart.plotTop + chart.plotHeight / 2 - 50 / 2) {
          //         chart.groupImage.attr({
          //           x: chart.plotLeft + chart.plotWidth / 2 - 20 / 2,
          //           y: chart.plotTop + chart.plotHeight / 2 - 20 / 2,
          //         });
          //       }
            
          //       if (chart.dottedBorder.attr('cx') !== chart.plotLeft + (chart.plotWidth / 2.05) + 7 ||
          //           chart.dottedBorder.attr('cy') !== chart.plotTop + (chart.plotHeight / 2) + 0) {
          //         chart.dottedBorder.attr({
          //           cx: chart.plotLeft + (chart.plotWidth / 2),
          //           cy: chart.plotTop + (chart.plotHeight / 2) + 0,
          //         });
          //       }
            
          //       return;
          //     }
            
          //     let imageUrl = chartimagepath;
            
          //     // Render the image if it doesn't exist
          //     if (!chart.groupImage) {
          //       chart.groupImage = chart.renderer
          //         .image(
          //           imageUrl,
          //           chart.plotLeft + chart.plotWidth / 2 - 20 / 2, // X position calculation
          //           chart.plotTop + chart.plotHeight / 2 - 20 / 2, // Y position calculation
          //           20,
          //           20
          //         )
          //         .attr({
          //           display: chartproperties.image ? 'block' : 'none',
          //         })
          //         .add();
          //     }
            
          //     // Render the dotted border if it doesn't exist
          //     if (!chart.dottedBorder) {
          //       let borderWidth = 1; // Border width
          //       let borderColor = chartproperties.darkTheme ? 'white' : '#333'; // Border color
          //       let centerX2 = chart.plotLeft + (chart.plotWidth / 2) ; // X position of the center
          //       let centerY2 = chart.plotTop + (chart.plotHeight / 2) + 0; // Y position of the center
          //       // let circleRadius = Math.min(chart.plotWidth, chart.plotHeight) / 7.5; // Radius of the circle
          //       let circleRadius="1.3em"
          //       chart.dottedBorder = chart.renderer
          //         .circle(centerX2, centerY2, circleRadius)
          //         .attr({
          //           fill: 'none', // Transparent fill
          //           'stroke-width': borderWidth,
          //           stroke: borderColor,
          //           dashstyle: 'Dash',
          //           display: chartproperties.innerBorder ? 'block' : 'none',
          //         })
          //         .add();
          //     }
            
          //     // Update the position of the elements when the chart is redrawn
          //     chart.addEvent('redraw', function () {
          //       chart.groupImage.attr({
          //         x: chart.plotLeft + chart.plotWidth / 2 - 50 / 2,
          //         y: chart.plotTop + chart.plotHeight / 2 - 50 / 2,
          //       });
            
          //       chart.dottedBorder.attr({
          //         cx: chart.plotLeft + (chart.plotWidth / 2.05) + 7,
          //         cy: chart.plotTop + (chart.plotHeight / 2) + 0,
          //       });
          //     });
          //   },
            
            
          // }
          },      
        title: {
          text: "",
          align: chartproperties.chartTitlePosition,
          verticalAlign: 'top',
          style: {
            color: chartproperties.darkTheme ? 'white' : 'black',
            fontSize: "2rem"
          },
        },
        legend: {
          navigation: {
            itemMarginLeft: 10,
            activeColor: '#7f7f7f',
            animation: true,
            arrowSize: 10,
            inactiveColor: '#ccc',
            enabled: true, // Explicitly enable navigation arrows
            
            style: {
              fontSize: '0.7em',
              color: chartproperties.darkTheme ? 'white' : '#333',
            },

          itemStyle: {
                color: chartproperties.darkTheme ? 'white' : 'black', // Change this to your desired color
                fontWeight: 'normal',
                fontSize: '0.8em'
            },
            verticalAlign:
        chartproperties.legendPosition != 'bottom' ? 'middle' : 'bottom',
          },
           layout:
        chartproperties.legendPosition != 'bottom'
          ? 'vertical'
          : 'horizontal',
          enabled:chartproperties.showLegend,
          // y:chartproperties.legendPosition == 'bottom'?0:4,
          maxHeight: this.getLegendMaxHeight(),
         // maxHeight: this.popUp ? (chartproperties.legendPosition == 'bottom' ? 60 : 300) : (chartproperties.legendPosition == 'bottom' ? 60 : 150), // Increased height for better spacing
          x: chartproperties.legendPosition == "left" ? 10 : this.getLegendXPosition(chartproperties, this.popUp),
          // x: this.popUp ? (chartproperties.legendPosition == 'right' ? 5 : (chartproperties.legendPosition == 'left' ? 80 : 0)) : chartproperties.legendPosition == 'right' ? 150 : (chartproperties.legendPosition == 'left' ? 5 : 20),
          //y: this.getLegendYPosition(),
    

  y: (chartproperties.legendPosition === 'left' || chartproperties.legendPosition === 'right') ? 0 : (chartproperties.legendPosition === 'bottom' ? (this.popUp ? -35 : -50) : 0),


          //  y: (() => {
           
          //   if (this.popUp) {
          //     return chartproperties.legendPosition == 'bottom' ? -35 : 20;
          //   } else {
          //     if (chartproperties.legendPosition === 'left' || chartproperties.legendPosition === 'right') {
          //       // Center vertically when insights panel is open
          //       return  -100;
          //     } else if (chartproperties.legendPosition === 'bottom') {
          //       return -50; // Slightly higher when open
          //     }
          //     return 0;
          //   }
          // })(),
    verticalAlign: chartproperties.legendPosition != 'bottom' ? 'middle' : 'bottom',
          // width: height=='100%'?100:'100%',
              itemWidth:this.getLegendItemWidth(chartproperties, this.popUp),
           // itemWidth: this.popUp?520:chartproperties.legendPosition=='bottom'?200:320, // Set legend item width (adjust as needed)
          align:  chartproperties.legendPosition,
      
          symbolWidth: 0,  // Set to a valid non-negative value
          symbolHeight: 0, // Set to a valid non-negative value
          //symbolWidth: -1,
          //symbolHeight: -1,
          useHTML: true,
          itemMarginTop: 0,    // Adjust this value to reduce the top margin
          
          itemMarginBottom:this.popUp? 0:-4,
          itemStyle: {
            fontWeight: "normal",
            // fontSize: '0.8em',
            fontSize:(0.8 * ((this.popUp || this.height === '100%') ? 1.45 : 1)) + 'em',
            cursor: 'pointer'
          },
            labelFormatter: function (): any {
              let point = this as any;
              let textcolor = chartproperties.darkTheme ? 'white' : 'black';
              let label = point.name;
              
              // Different handling for popup vs non-popup mode
                       if (!popUpState) {
  // Set legend item width
  const currentItemWidth =
    chartproperties.legendPosition === 'bottom'
      ? 200
      : getLegendItemWidth(chartproperties, popUpState);

  // Constants for spacing and font estimation
  const iconWidth = 10;
  const paddingLeft = 10;
  const availableWidth = currentItemWidth - iconWidth - paddingLeft;

  const fontSize = 0.8; // in em
  const avgCharWidth = fontSize * 8; // px per character (approx)
  const charsPerLine = Math.floor(availableWidth / avgCharWidth);

  // Split label into words
  const words = label.split(' ');
  let line1 = '';
  let line2 = '';
  let currentLine = '';

  for (let i = 0; i < words.length; i++) {
    const testLine = currentLine.length > 0 ? currentLine + ' ' + words[i] : words[i];

    if (testLine.length <= charsPerLine) {
      currentLine = testLine; // word fits, keep adding
    } else {
      if (line1 === '') {
        // Move currentLine to first line and start second line
        line1 = currentLine;
        currentLine = words[i]; // start second line
      } else {
        // Exceeded second line → truncate
        line2 = currentLine;
        currentLine = words[i];
        break;
      }
    }
  }

  // Assign remaining text
  if (!line1) {
    line1 = currentLine;
  } else if (!line2) {
    line2 = currentLine;
  }

  // If still words left beyond 2 lines → truncate second line
  const remainingWords = words.join(' ').length > (line1 + line2).length;
  if (remainingWords && line2.length > charsPerLine - 3) {
    line2 = line2.slice(0, charsPerLine - 3) + '...';
  }

  // Build final label
  if (line2) {
    label = `${line1}<br>${line2}`;
  } else {
    label = line1;
  }
}else {
                // For popup mode: original logic (single line break)
                const maxLen = 300;
                if (label.length > maxLen) {
                  const idx = label.lastIndexOf(' ', maxLen);
                  if (idx > 0) {
                    label = label.slice(0, idx) + '<br>' + label.slice(idx + 1);
                  }
                }
              }
              
              if (point.color != "#eeebed" && point.color != "#7f7f7f") {
                let legendMarginBottom = (chartproperties.legendPosition === 'left' || chartproperties.legendPosition === 'right') ? 'margin-bottom:4px;' : 'margin-bottom:2px;';
                
                // Apply position relative and left offset only for bottom legend position
                let positionStyle = chartproperties.legendPosition == 'bottom' ? '' : ''; // Remove left positioning to prevent overlap
                
                // Calculate legend width based on popup state and available space
                let legendWidth;
                if (popUpState) {
                  // Use fixed width for popup mode
                  if (chartproperties.legendPosition == 'bottom') {
                    legendWidth = '12rem'; // Smaller width for bottom legends to fit side by side
                  } else {
                    legendWidth = height != "100%" ? '30rem' : '29.5rem';
                  }
                } else {
                  if (chartproperties.legendPosition == 'bottom') {
                    // For bottom position, use smaller fixed width to allow side-by-side display
                    legendWidth = '25rem';
                  } else {
                    // Calculate available width for non-popup mode
                    const containerElement = document.getElementById('chart-container' + componentId);
                    if (containerElement) {
                      const containerWidth = containerElement.offsetWidth;
                      // Get chart size from responsive props (we'll use a fallback calculation)
                      const chartSizePercentage = chartproperties?.showLegend ? 0.65 : 0.75; // Based on our earlier size logic
                      const chartWidth = containerWidth * chartSizePercentage;
                      const availableWidth = containerWidth - chartWidth - 20; // 30px buffer
                      legendWidth = Math.max(150, availableWidth) + 'px'; // Minimum 150px width
                    } else {
                      legendWidth = '200px'; // Fallback width
                    }
                  }
                }
                
                return '<div style="display:flex;align-items:center;font-size:0.8em;'  +positionStyle+ legendMarginBottom + '" title="' + point.name + '">' 
                  + '<div style="display:flex;width:10px;height:10px;background-color:' + point.legendkeycolor + ';border-radius:50%"></div>'
                  + '<div style="width:' + legendWidth + ';font-size:0.8em;padding-left:10px;padding-top:'+ (popUpState ? '1px' : '5px')+';color:' + textcolor + ';overflow:visible;white-space:normal;text-overflow:ellipsis;flex:1;line-height:1.2;" title="' + point.name + '">' + '   ' + label + '   ' + '</div>'
                  + '</div>';
              }
            },
        },
      tooltip: {
          enabled: true,
          borderWidth: 1,
          useHTML: true,
          shape: 'square',
          shadow: false,
          backgroundColor:  'white',  
          outside: popUpState ? false : true,
          style: {
            fontSize: '0.9rem'
          },
          formatter: function (this: any): any {
            const pointWithMetric = this.point as {
              name?: any;
              parent?: any;
              color?: any;
              actualcolor?: any;
              y?: number;
              y1?: number;
              cov?: string;
              significance?: string;
              significance2?: string;
              samplesize?: number;
              tooltip?: any;
              Significance_Value?: any;
            };
            if (pointWithMetric.color === '#eeebed' || pointWithMetric.color === '#7f7f7f') { return false };
            const backgroundcolor = chartproperties.darkTheme ? '#b3b3b3' : '#f5f5f5';
            const backgroundcolor2 = chartproperties.darkTheme ? '#dddddd' : 'white';
            if (pointWithMetric.tooltip == "") { pointWithMetric.tooltip = pointWithMetric.y1 == null ? 'NA' : pointWithMetric.y }

            let isDefaultTooltip = chartproperties.toolTipStyle;
            if (isDefaultTooltip == "style1") {
              const dotColor = pointWithMetric.actualcolor;
              this.point.series.tooltipOptions.borderColor = dotColor;
              this.point.series.tooltipOptions.borderWidth=10;
             const content =
    `<div class="high-z-tooltip" style="background: #fff;  min-width: 220px; font-size: 0.7em; display: flex; box-shadow: none;align-items: center;z-index:999 !important;padding:2px;">
      <span style=" width:10px; height:10px; border-radius:50%; background:${dotColor}; margin-right:8px; vertical-align:middle;"></span>
      <span>${pointWithMetric.name}: </span>
      <b style="margin-left:4px;">${pointWithMetric.tooltip}</b>
    </div>`;
  return content;
              return content + '</div>';
            }
            else if (chartproperties.datalabelStyle === 'sigChange') {

            }
            else {
              const dotColor = pointWithMetric.actualcolor; // Get the series color

             
                const commonContent =
                `<div style="border-left: 2px solid ` + dotColor + `;font-size:0.8em; border-bottom: 2px solid ` + dotColor + `; z-index: 100; padding: 5px; border-radius: 5px; margin: 0px; background-color :${backgroundcolor2};">` +
                // `<span style="display: block; text-align: center; color: `+dotColor+`; font-weight: bold; font-size: 12px;">Tooltip Title</span>` +
                // `<span><strong>Series Name:</strong></span>Brands<br>` +
                ` ${pointWithMetric.name} : ` +
                `${pointWithMetric.tooltip}`;
              return commonContent + '</div>';

            }



          },
        },
        plotOptions: {
          series: {
            allowPointSelect: false,
            states: {
              hover: {
                enabled: false
              },
              inactive: {
                enabled: false
              },
              select: {
                enabled: false
              }
            }
          },
          pie: {
            // Center the pie chart vertically with dynamic positioning
            center: this.getResponsiveChartProps().center,
            size: this.getResponsiveChartProps().size, // Reduced popup size from 80% to 50%
           innerSize: this.getResponsiveChartProps().innerSize,
            showInLegend: chartproperties.showLegend,
            borderRadius: 0,   // removes rounded corners
            borderWidth: 0,    // removes the border outline
            slicedOffset: 10,
            shadow: chartproperties.shadow ? {
              color: chartproperties.darkTheme?'white':'rgba(0, 0, 0, 0.5)',
              offsetX: 1,
              offsetY: 1,
              opacity: 0.5,
              width: 6,
           } : false,
            // size: '95%',
            // innerSize: '60%',
            // showInLegend: chartproperties.showLegend,
            // borderWidth: this.height == "100%" ? 2 : 0,
            // borderColor: 'white',
            // slicedOffset: 10,
            // shadow: chartproperties.shadow ? {
            //   color: 'rgba(0, 0, 0, 0.5)',
            //   offsetX: 1,
            //   offsetY: 1,
            //   opacity: 0.5,
            //   width: 6,
            // } : false,
            dataLabels: {
              allowOverlap: true,
              align: 'left',
              verticalAlign: 'middle',
              //alignTo: 'connectors',
              //y: 0,
              style: {
                textOutline: 'none',
                fontSize: chartproperties.dataLabelSize,
                fontWeight: "normal"
              },
              //padding:10,
              color:
                chartproperties.dataLabelColor == 'default'
                  ? chartproperties.darkTheme
                    ? 'white'
                    : 'black'
                  : chartproperties.dataLabelColor,
              crop: false,
              enabled: chartproperties.showDataLabel,
              // connectorWidth: chartproperties.connector ? 1 : -1,
              // connectorColor: null,
              // //color: chartproperties.dataLabelColor == "default" ? (chartproperties.darkTheme ? 'white' : 'black') : chartproperties.dataLabelColor,
              // connectorPadding: 0,
              // distance: chartproperties.connector ? 20 : 50,
              // connectorShape: 'crookedLine',
              // crookDistance: '70%',
              // softConnector: false,
              inside:false,
              distance: 0,
              x: -30,
              y: -5,
              connectorWidth: -1,
              useHtml: true,
              formatter: function (this: Highcharts.TooltipFormatterContextObject): any {
                const pointWithMetric = this.point as {
                  name?: any;
                  parent?: any;
                  color?: any;
                  y?: number;
                  y1?: number;
                  cov?: string;
                  significance?: string;
                  samplesize?: number;
                  significance2?: any;
                  tooltip?: any;
                  isPercentage?: any;
                  Sig_LowerLimt?: any;
                  Sig_UpperLimt?: any;
                  Significance_Value?: any;
                  indexValue?: any;
                  actualIndexValue?: any;
                };
                if (this.point.color !== '#eeebed' && this.color != '#7f7f7f') {

                  chartproperties.dataLabelFormat = pointWithMetric.isPercentage;
                  ;
                  let textcolor = chartproperties.dataLabelColor;
                  if (chartproperties.datalabelStyle == 'datalabel') {
                    ;
                    let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') : 'NA';
                    text = configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize));
                    pointWithMetric.tooltip = text;
                    return (
                      '<span style="color:' + textcolor + ';font-size:'+ chartproperties.dataLabelSize +'">' + text + '</span>'
                    );
                  }
                  //new
                  if (chartproperties.datalabelStyle === "index") {

                    let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') : 'NA';
                    text = configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize));

                    // let text2 = pointWithMetric.y1 == 0 ? 'NA' :pointWithMetric.y1 == -1 ? -1 : pointWithMetric.y1 != null ? pointWithMetric.indexValue.toFixed(1) : 'NA';
                    let text2 = pointWithMetric.actualIndexValue == null ? 'NA' : pointWithMetric.y1 == -1 ? -1 : pointWithMetric.y1 != null ? pointWithMetric.indexValue.toFixed(1) : 'NA';

                    if (text2 == "-1" || text2 == -1) {
                      text2 = "NA";
                    }
                    text2 = configService.CheckLSorIScondition(configService.userRole, String(text2), Number(pointWithMetric.samplesize));

                    let color = configService.CheckIndexColoring(String(text2));
                    pointWithMetric.tooltip = text + "(" + text2 + ")";
                    return (
                      '<span style="font-size:0.5rem;color:' + textcolor + ';">' + text + " " + '(' +
                      '<span style="color:' + color + ';font-size:0.45rem;">' + text2 + '</span>' + ')</span>'
                    );
                  }

                  if (chartproperties.datalabelStyle === 'sigChange') {
                    let textCheck = configService.CheckLSorIScondition(configService.userRole, String(pointWithMetric.y), Number(pointWithMetric.samplesize));
                    let changeVal = pointWithMetric.isPercentage ? (Number(pointWithMetric.cov) * 100) : (Number(pointWithMetric.cov));
                    if (pointWithMetric.cov == null || pointWithMetric.cov == 'NA') {
                      let text = textCheck + (chartproperties.dataLabelFormat ? '%' : '') + ' ' + `<span span style="font-size: 80%;color:black;">(${'NA'})</span>`;
                      pointWithMetric.tooltip = text;
                      return (
                        '<span style="color:' + textcolor + ';font-size:'+ chartproperties.dataLabelSize +'">' + text + '</span>'
                      );
                    }
                    else {
                      let sigClass = pointWithMetric.Significance_Value < pointWithMetric.Sig_LowerLimt ? 'red' : (pointWithMetric.Significance_Value > pointWithMetric.Sig_UpperLimt ? 'green' : 'black');
                      //let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + ' ' + (textCheck !='I/S' ? (`<span style="font-size: 80%;  color: ${sigClass};">(` + `${pointWithMetric.cov != null ? parseFloat(Number(changeVal).toFixed(1)) : 'NA'})</span>` : 'NA') : '');
                      let text = textCheck + ((chartproperties.dataLabelFormat && textCheck != 'I/S') ? '%' : '') + ' ' + (textCheck != 'I/S' ? (`<span style="font-size: 80%;  color: ${sigClass};">(` + `${(pointWithMetric.cov != null ? parseFloat(Number(changeVal).toFixed(1)) + (chartproperties.dataLabelFormat ? '%' : '') : 'NA')})</span>`) : '');
                      pointWithMetric.tooltip = text;
                      return (
                        '<span style="color:' + textcolor + ';font-size:'+ chartproperties.dataLabelSize +'">' + text + '</span>'
                      );

                    }

                  }
                  if (chartproperties.datalabelStyle === 'change') {
                    let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + ' ' + `<span span style="font-size: 80%;color:` + (chartproperties.darkTheme ? 'white' : 'black') + `">(` + `${pointWithMetric.cov} )</span>` : 'NA';
                    pointWithMetric.tooltip = text;
                    return (
                      '<span style:"color:' + textcolor + ';font-size:'+ chartproperties.dataLabelSize +'">' + text + '</span>'
                    );
                  }
                  if (chartproperties.datalabelStyle === 'significance + changeVs') {
                    const upwardTriangle = '\u25B2';
                    const downwardTriangle = '\u25BC';
                    let sig = Number(pointWithMetric.significance);
                    let s =
                      sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                    let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
                    let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + ' ' + `<span span style="font-size: 80%;color:` + (chartproperties.darkTheme ? 'white' : 'black') + `">(` + `${pointWithMetric.cov} )</span>` + '<span style="color:' +
                      sigcolor +
                      ';">' +
                      s +
                      '</span>' : 'NA';
                    pointWithMetric.tooltip = text;
                    return (
                      '<span style:"color:' +
                      textcolor +
                      ';font-size:'+ chartproperties.dataLabelSize +'">' +
                      text +
                      '</span>'
                    );
                  }
                  if (chartproperties.datalabelStyle == 'significance') {
                    const upwardTriangle = '\u25B2';
                    const downwardTriangle = '\u25BC';
                    let sig = pointWithMetric.significance;
                    let s =
                      Number(sig) > 0 ? upwardTriangle : Number(sig) < 0 ? downwardTriangle : '';
                    let sigcolor = Number(sig) > 0 ? 'green' : Number(sig) < 0 ? 'red' : '';
                    let text = pointWithMetric.y1 != null ? (pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + '<span style="color:' + sigcolor + ';">' + s + '</span>') : 'NA';
                    pointWithMetric.tooltip = text;
                    return (
                      '<span style:"color:' +
                      textcolor +
                      ';font-size:'+ chartproperties.dataLabelSize +'">' +
                      text +
                      '</span>'
                    );
                  }
                  if (chartproperties.datalabelStyle == 'ls') {
                    let text = Number(pointWithMetric.samplesize) > samplesizeconstant ? (pointWithMetric.y1 == null ? 'NA' : pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '')) : 'LS';
                    pointWithMetric.tooltip = text;
                    return (
                      '<span style:"color:' + textcolor + ';font-size:'+ chartproperties.dataLabelSize +'">' + text + '</span>'
                    );
                  }
                  if (chartproperties.datalabelStyle == "significance2") {
                    const upwardTriangle = '\u25B2';
                    const downwardTriangle = '\u25BC';
                    let text = pointWithMetric.y1 != null ? this.y + (chartproperties.dataLabelFormat ? '%' : '') : 'NA';
                    let changeText = pointWithMetric.cov;
                    let sig = pointWithMetric.significance;
                    let sig1 = pointWithMetric.significance2;
                    let sColor = Number(sig) > 0 ? 'green' : (Number(sig) < 0 ? 'red' : '');
                    let s = Number(sig) > 0 ? upwardTriangle : (Number(sig) < 0 ? downwardTriangle : '');
                    let changeColor = sig1 < 0 ? 'red' : (sig1 > 0 ? 'green' : (chartproperties.darkTheme ? 'white' : 'black'));

                    if (Number(changeText) > 0) {
                      changeText = "+" + changeText;
                    }
                    pointWithMetric.tooltip = '<span>' + text +
                      (pointWithMetric.y1 != null && changeText ? '&nbsp<span style="color:' + ';"> ' +
                        '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span> &nbsp' +
                        '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                      '</span>';
                    return (
                      '<span>' + text +
                      (pointWithMetric.y1 != null && changeText ? '&nbsp<span style="color:' + ';"> ' +
                        '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span> &nbsp' +
                        '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                      '</span>'
                    );
                  }
                } else {
                  return null;
                }
              },
            }

          }
        },
        series: this.seriesdata,
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        }
      } as any,
      );

      // window.addEventListener('resize', () => {
      //   if (this.chart) {
      //     this.chart.reflow();  // Forces Highcharts to reflow and resize the chart
      //   }
      // });
      
      // Force reflow when popup state changes
      setTimeout(() => {
        if (this.chart) {
          this.chart.reflow();
        }
      }, 100);
      
    }
    else{
      localStorage.setItem("properties",JSON.stringify(this.chartproperties));
      let samplesizeconstant=this.samplesizeconstant;
      let popupState=this.popUp;
      let chartimagepath=this.chartimagepath;
      this.preparechartdata(jsondata,chartproperties.datalabelStyle=='ls',chartproperties.gradientBarColor,chartproperties.darkTheme);
      const containerEl = document.getElementById(containerId);
      if (!containerEl) { return; }
      this.chart = Highcharts.chart(containerEl, {
        accessibility: {
          point: {
            valueSuffix: '%'
          }
        },
        chart: {
          type: 'pie',
          marginBottom:50,
          // height: this.popUp ? null : 420, // Use null for popup to auto-adjust height
          backgroundColor: chartproperties.darkTheme ? '#333' : 'white',
          style:{
            fontFamily: this.piechartservice.fontFamily,
          },
          events:{
render: function (this: Highcharts.Chart) {
  const legend = this.legend && (this.legend as any).group;
  if (
    this.options.legend &&
    this.legend &&
    (this.legend.options.align === 'left' || this.legend.options.align === 'right')
  ) {
    // Use plotHeight and plotTop for accurate centering
    const plotTop = this.plotTop;
    const plotHeight = this.plotHeight;
    const legendBBox = legend.getBBox();
    const legendHeight = legendBBox.height;

    // Center legend in the plot area and move it up by 20px (adjust -20 as needed)
    const newY = plotTop + Math.max(0, Math.round((plotHeight - legendHeight) / 2)) - 20;
    legend.attr({ translateY: newY });
  }
}
            
            
          }
        },
        title: {
          text: "", //this.jsondata.title,
          //align:chartproperties.chartTitlePosition,
          //verticalAlign: 'top',
          style: {
            color: chartproperties.darkTheme ? 'white' : 'black',
            fontSize:"0.8em"
          },
        },
        legend: {
          navigation: {
            itemMarginLeft: 10,
            activeColor: '#7f7f7f',
            animation: true,
            arrowSize: 10,
            inactiveColor: '#ccc',
            style: {
                fontSize: '0.7em',
                color: chartproperties.darkTheme?'white':'#333',
            }
          },
           x: this.popUp ? (chartproperties.legendPosition == 'right' ? -80 : chartproperties.legendPosition == 'left' ? 80 : 0) : (chartproperties.legendPosition == 'right' ? -50 : chartproperties.legendPosition == 'left' ? 40 : 0),
          y:chartproperties.legendPosition == 'bottom' ? 35 : 1,
          maxHeight: chartproperties.legendPosition == 'bottom'?50:300,
          layout:
          chartproperties.legendPosition != 'bottom'
            ? 'vertical'
            : 'horizontal',
        align: chartproperties.legendPosition,
        verticalAlign:
          chartproperties.legendPosition != 'bottom' ? 'middle' : 'bottom',
          symbolWidth: -1,
          symbolHeight: -1,
          useHTML:true,
          itemStyle:{
            fontWeight:"normal",
            fontSize: '0.8em',
          },
          labelFormatter: function (): any {
            let point = this as any;
            let textcolor= chartproperties.darkTheme ? 'white' : 'black';
      if (point.color != "#eeebed" && point.color != "#7f7f7f") 
      {
        // Use CSS-based truncation based on available space - max 2 lines with ellipsis
        
        return '<div style="display:flex;margin-bottom:1px;align-items:flex-start;font-size:0.7em">'
        + '<div style="display:flex;width:10px;height:10px;background-color:' + point.color + ';margin-top:5px;flex-shrink:0;"></div>'
        + '<div style="width:' + (popupState ? '380px' : '120px') + ';max-height:2.6em;padding-left:10px;padding-top:3px;padding-bottom:3px;box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);color:'+textcolor+';white-space:normal;overflow-wrap:break-word;word-wrap:break-word;line-height:1.3;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;">' + '   ' + point.name + '   '+ '</div>'
        + '</div>';        
            }
          },
        },
      tooltip: {
          enabled: true,
          borderWidth: 1,
          useHTML: true,
          shape: 'callout',
          shadow: false,
          backgroundColor:  'white',  
          outside:true,
          style: {
            fontSize: '0.9rem'
          },
          formatter: function (this: any): any {
            const pointWithMetric = this.point as {
              name?: any;
              parent?: any;
              color?: any;
              actualcolor?: any;
              y?: number;
              y1?: number;
              cov?: string;
              significance?: string;
              significance2?: string;
              samplesize?: number;
              tooltip?: any;
              Significance_Value?: any;
            };
            if (pointWithMetric.color === '#eeebed' || pointWithMetric.color === '#7f7f7f') { return false };
            const backgroundcolor = chartproperties.darkTheme ? '#b3b3b3' : '#f5f5f5';
            const backgroundcolor2 = chartproperties.darkTheme ? '#dddddd' : 'white';
            if (pointWithMetric.tooltip == "") { pointWithMetric.tooltip = pointWithMetric.y1 == null ? 'NA' : pointWithMetric.y }

            let isDefaultTooltip = chartproperties.toolTipStyle;
          
            if (isDefaultTooltip == "style1") {
              const dotColor = pointWithMetric.color;
              this.point.series.tooltipOptions.borderColor = dotColor;
              this.point.series.tooltipOptions.borderWidth=10;
             const content =
    `<div class="high-z-tooltip" style="background: #fff;  min-width: 220px; font-size: 0.7em; display: flex; box-shadow: none;align-items: center;z-index:999 !important;padding:2px;">
      <span style=" width:10px; height:10px; border-radius:50%; background:${dotColor}; margin-right:8px; vertical-align:middle;"></span>
      <span>${pointWithMetric.name}: </span>
      <b style="margin-left:4px;">${pointWithMetric.tooltip}</b>
    </div>`;
  return content;
              return content + '</div>';
            }
            else if (chartproperties.datalabelStyle === 'sigChange') {

            }
            else {
              const dotColor = pointWithMetric.color; // Get the series color

             
                const commonContent =
                `<div style="border-left: 2px solid ` + dotColor + `;font-size:0.8em; border-bottom: 2px solid ` + dotColor + `; z-index: 100; padding: 5px; border-radius: 5px; margin: 0px; background-color :${backgroundcolor2};">` +
                // `<span style="display: block; text-align: center; color: `+dotColor+`; font-weight: bold; font-size: 12px;">Tooltip Title</span>` +
                // `<span><strong>Series Name:</strong></span>Brands<br>` +
                ` ${pointWithMetric.name} : ` +
                `${pointWithMetric.tooltip}`;
              return commonContent + '</div>';

            }



          },
        },
        plotOptions: {  
          pie: {
            // Center the pie chart vertically with dynamic positioning
            center: ['50%', '50%'],
            innerSize: '5%', // was '100%'
            size:  '85%', // Corrected size for normal view
           
            showInLegend: chartproperties.showLegend,
            borderWidth: 1,
            borderColor: null,
            slicedOffset: 10,
            shadow: chartproperties.shadow ? {
              color: chartproperties.darkTheme?'white':'rgba(0, 0, 0, 0.5)',
              offsetX: 1,
              offsetY: 1,
              opacity: 0.5,
              width: 6,
           } : false,
            dataLabels: {
              y: -5,
              style: {
                textOutline: 'none',
                fontSize: chartproperties.dataLabelSize,
                fontWeight:"normal"
              },
              align:'left',
              verticalAlign: 'middle',
              enabled: chartproperties.showDataLabel,
              connectorWidth: chartproperties.connector?1:-1,
              connectorColor: null,
               color:chartproperties.dataLabelColor=="default"?(chartproperties.darkTheme?'white':'black'):chartproperties.dataLabelColor,
              connectorPadding: 0,
              distance: chartproperties.connector?10:-10,
              x: -30,
              useHtml: true,
              formatter: function (this: Highcharts.TooltipFormatterContextObject): any {
                const pointWithMetric = this.point as {
                  name?:any;
                  parent?:any;
                  color?:any;
                  y?: number;
                  y1?:number;
                  cov?: string;
                  significance?: string;
                  samplesize?: number;
                  significance2?:any;
                  tooltip?:any;
                };
                if (this.point.color !== '#eeebed' && this.color!='#7f7f7f') {
                  let textcolor = chartproperties.darkTheme ? 'white' : 'black';
                  if (chartproperties.datalabelStyle == 'datalabel') {
                    let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat?'%':'') : 'NA';
                    pointWithMetric.tooltip=text;
                    return (
                      '<span style:"color:' + textcolor + ';">' + text + '</span>'
                    );
                  }
                  if (chartproperties.datalabelStyle === 'change') {
                    let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat?'%':'')+' ' + `<span span style="font-size: 80%;color:`+(chartproperties.darkTheme?'white':'black')+`">(`+(Number(pointWithMetric.cov)>0?'+':'')+`${pointWithMetric.cov} )</span>` : 'NA';
                    pointWithMetric.tooltip=text;
                    return (
                      '<span style:"color:' + textcolor + ';">' + text + '</span>'
                    );
                  }
                   if (chartproperties.datalabelStyle === 'significance + changeVs') {
                    const upwardTriangle = '\u25B2';
                    const downwardTriangle = '\u25BC';
                    let sig = Number(pointWithMetric.significance);
                    let s =
                      sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                    let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
                    let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat?'%':'')+' ' +  `<span span style="font-size: 80%;color:`+(chartproperties.darkTheme?'white':'black')+`">(`+(Number(pointWithMetric.cov)>0?'+':'')+`${pointWithMetric.cov} )</span>` +  '<span style="color:' +
                    sigcolor +
                    ';">' +
                    s +
                    '</span>' : 'NA';
                    pointWithMetric.tooltip=text;
                    return (
                      '<span style:"color:' +
                      textcolor +
                      ';">' +
                      text +
                     '</span>'
                    );
                  }
                  if (chartproperties.datalabelStyle == 'significance') {
                    const upwardTriangle = '\u25B2';
                    const downwardTriangle = '\u25BC';
                    let sig = pointWithMetric.significance;
                    let s =
                    Number(sig) > 0 ? upwardTriangle : Number(sig )< 0 ? downwardTriangle : '';
                  let sigcolor = Number(sig) > 0 ? 'green' : Number(sig) < 0 ? 'red' : '';
                    let text = pointWithMetric.y1 != null ? (pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') +'<span style="color:' +sigcolor +';">' +s +'</span>'): 'NA';
                    pointWithMetric.tooltip=text;
                    return (
                      '<span style:"color:' +
                      textcolor +
                      ';">' +
                      text +
                      '</span>'
                    );
                  }
                  if (chartproperties.datalabelStyle == 'ls') {
                    let text = Number(pointWithMetric.samplesize)>samplesizeconstant?(pointWithMetric.y1 == null ? 'NA' : pointWithMetric.y + (chartproperties.dataLabelFormat?'%':'')):'LS';
                    pointWithMetric.tooltip=text;
                    return (
                      '<span style:"color:' + textcolor + ';">' + text + '</span>'
                    );
                  }
                  if (chartproperties.datalabelStyle == "significance2") {
                    const upwardTriangle = '\u25B2';
                    const downwardTriangle = '\u25BC';
                    let text = pointWithMetric.y1 != null ? this.y + (chartproperties.dataLabelFormat?'%':'') : 'NA';
                    let changeText = pointWithMetric.cov;
                    let sig = pointWithMetric.significance;
                    let sig1 = pointWithMetric.significance2;
                    let sColor = Number(sig) > 0 ? 'green' : (Number(sig) < 0 ? 'red' : '');
                    let s = Number(sig) > 0 ? upwardTriangle : (Number(sig) < 0 ? downwardTriangle : '');
                    let changeColor = sig1 < 0 ? 'red' : (sig1 > 0 ? 'green' : (chartproperties.darkTheme?'white':'black'));
    
                    if (Number(changeText) > 0) {
                      changeText = "+" + changeText;
                    }
                    pointWithMetric.tooltip= '<span>' + text +
                    (pointWithMetric.y1 != null && changeText ? '&nbsp<span style="color:' + ';"> ' +
                      '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span> &nbsp' +
                      '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                    '</span>';
                    return (
                      '<span>' + text +
                      (pointWithMetric.y1 != null && changeText ? '&nbsp<span style="color:' + ';"> ' +
                        '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span> &nbsp' +
                        '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                      '</span>'
                    );
                  }
                } else {
                  return null;
                }
              },
            }
  
          }
        },
        series:this.seriesdata,
        credits: {
          enabled: false
        },
        exporting:{
          enabled:false
        }
      } as any,
      );
    }

    // localStorage.setItem("properties",JSON.stringify(this.chartproperties));
    // let samplesizeconstant=this.samplesizeconstant;
    // let chartimagepath=this.chartimagepath;
    // this.preparechartdata(jsondata,chartproperties.datalabelStyle=='ls',chartproperties.gradientBarColor,chartproperties.darkTheme);
    // this.chart = Highcharts.chart(containerId, {
    //   accessibility: {
    //     point: {
    //       valueSuffix: '%'
    //     }
    //   },
    //   chart: {
    //     type: 'pie',
    //     marginBottom:50,
    //     backgroundColor: chartproperties.darkTheme ? '#333' : 'white',
    //     style:{
    //       fontFamily: this.piechartservice.fontFamily,
    //     },
    //     events:{
    //       render: function () {
    //         const chart = this as any;
          
    //         // Check if the image and circle already exist, and return without rendering if they do
    //         if (chart.groupImage && chart.dottedBorder) {
    //           // Update the position of existing elements if the chart position changes
    //           if (chart.groupImage.attr('x') !== chart.plotLeft + chart.plotWidth / 2 - 50 / 2 ||
    //               chart.groupImage.attr('y') !== chart.plotTop + chart.plotHeight / 2 - 50 / 2) {
    //             chart.groupImage.attr({
    //               x: chart.plotLeft + chart.plotWidth / 2 - 20 / 2,
    //               y: chart.plotTop + chart.plotHeight / 2 - 20 / 2,
    //             });
    //           }
          
    //           if (chart.dottedBorder.attr('cx') !== chart.plotLeft + (chart.plotWidth / 2.05) + 7 ||
    //               chart.dottedBorder.attr('cy') !== chart.plotTop + (chart.plotHeight / 2) + 0) {
    //             chart.dottedBorder.attr({
    //               cx: chart.plotLeft + (chart.plotWidth / 2),
    //               cy: chart.plotTop + (chart.plotHeight / 2) + 0,
    //             });
    //           }
          
    //           return;
    //         }
          
    //         let imageUrl = chartimagepath;
          
    //         // Render the image if it doesn't exist
    //         if (!chart.groupImage) {
    //           chart.groupImage = chart.renderer
    //             .image(
    //               imageUrl,
    //               chart.plotLeft + chart.plotWidth / 2 - 20 / 2, // X position calculation
    //               chart.plotTop + chart.plotHeight / 2 - 20 / 2, // Y position calculation
    //               20,
    //               20
    //             )
    //             .attr({
    //               display: chartproperties.image ? 'block' : 'none',
    //             })
    //             .add();
    //         }
          
    //         // Render the dotted border if it doesn't exist
    //         if (!chart.dottedBorder) {
    //           let borderWidth = 1; // Border width
    //           let borderColor = chartproperties.darkTheme ? 'white' : '#333'; // Border color
    //           let centerX2 = chart.plotLeft + (chart.plotWidth / 2) ; // X position of the center
    //           let centerY2 = chart.plotTop + (chart.plotHeight / 2) + 0; // Y position of the center
    //           // let circleRadius = Math.min(chart.plotWidth, chart.plotHeight) / 7.5; // Radius of the circle
    //           let circleRadius="1.3em"
    //           chart.dottedBorder = chart.renderer
    //             .circle(centerX2, centerY2, circleRadius)
    //             .attr({
    //               fill: 'none', // Transparent fill
    //               'stroke-width': borderWidth,
    //               stroke: borderColor,
    //               dashstyle: 'Dash',
    //               display: chartproperties.innerBorder ? 'block' : 'none',
    //             })
    //             .add();
    //         }
          
    //         // Update the position of the elements when the chart is redrawn
    //         chart.addEvent('redraw', function () {
    //           chart.groupImage.attr({
    //             x: chart.plotLeft + chart.plotWidth / 2 - 50 / 2,
    //             y: chart.plotTop + chart.plotHeight / 2 - 50 / 2,
    //           });
          
    //           chart.dottedBorder.attr({
    //             cx: chart.plotLeft + (chart.plotWidth / 2.05) + 7,
    //             cy: chart.plotTop + (chart.plotHeight / 2) + 0,
    //           });
    //         });
    //       },
          
          
    //     }
    //   },
    //   title: {
    //     text: "", //this.jsondata.title,
    //     //align:chartproperties.chartTitlePosition,
    //     //verticalAlign: 'top',
    //     style: {
    //       color: chartproperties.darkTheme ? 'white' : 'black',
    //       fontSize:"0em"
    //     },
    //   },
    //   legend: {
    //     navigation: {
    //       itemMarginLeft: 10,
    //       activeColor: '#7f7f7f',
    //       animation: true,
    //       arrowSize: 10,
    //       inactiveColor: '#ccc',
    //       style: {
    //           fontSize: '0.7em',
    //           color: chartproperties.darkTheme?'white':'#333',
    //       }
    //     },
    //     y:chartproperties.legendPosition == 'bottom'?10:4,
    //     maxHeight: chartproperties.legendPosition == 'bottom'?45:300,
    //     layout:
    //     chartproperties.legendPosition != 'bottom'
    //       ? 'vertical'
    //       : 'horizontal',
    //   align: chartproperties.legendPosition,
    //   verticalAlign:
    //     chartproperties.legendPosition != 'bottom' ? 'middle' : 'bottom',
    //     symbolWidth: -1,
    //     symbolHeight: -1,
    //     useHTML:true,
    //     itemStyle:{
    //       fontWeight:"normal",
    //       fontSize: '0.8em',
    //     },
    //     labelFormatter: function (): any {
    //       let point = this as any;
    //       let textcolor= chartproperties.darkTheme ? 'white' : 'black';
    //       if (point.color != "#eeebed" && point.color != "#7f7f7f") 
    //       {
    //         return '<div style="display:flex;margin-bottom:2px;align-items:center;font-size:0.8em">'
    //         + '<div style="display:flex;width:10px;height:20px;background-color:' + point.legendkeycolor + ';"></div>'
    //         + '<div style="display:flex;width:60px;height:20px;padding-left:10px;padding-top:5px;box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);color:'+textcolor+';">' + '   ' + point.name + '   '+ '</div>'
    //         + '</div>';        
    //       }
    //     },
    //   },
    //   tooltip: {
    //     enabled: true,
    //     borderWidth: 0,
    //     useHTML: true,
    //     shape: chartproperties.toolTipStyle == "style1" ? 'square' : 'callout',
    //     shadow: false,
    //     backgroundColor: 'rgba(0,0,0,0)',
        
      
    //     formatter: function (this: any):any {
    //       const pointWithMetric = this.point as {
    //         name?:any;
    //         parent?:any;
    //         color?:any;
    //         actualcolor?:any;
    //         y?: number;
    //         y1?:number;
    //         cov?: string;
    //         significance?: string;
    //         significance2?: string;
    //         samplesize?: number;
    //         tooltip?:any
    //       };
    //       if(pointWithMetric.color==='#eeebed' || pointWithMetric.color==='#7f7f7f'){return false};
    //       const backgroundcolor = chartproperties.darkTheme ? '#b3b3b3' : '#f5f5f5';
    //       const backgroundcolor2 = chartproperties.darkTheme ? '#dddddd' : 'white';
    //       if(pointWithMetric.tooltip==""){pointWithMetric.tooltip=pointWithMetric.y1==null?'NA':pointWithMetric.y}

    //       let isDefaultTooltip = chartproperties.toolTipStyle;
    //       if (isDefaultTooltip == "style1") {
    //         const dotColor = pointWithMetric.actualcolor;
    //         const commonContent =
    //           `<div style="border-left: 5px solid `+dotColor+`; border-bottom: 5px solid `+dotColor+`; z-index: 100; padding: 5px; border-radius: 5px; margin: 0px; background-color :${backgroundcolor2};">` +
    //           `<span style="display: block; text-align: center; color: `+dotColor+`; font-weight: bold; font-size: 12px;">Tooltip Title</span>` +
    //           `<span><strong>Series Name:</strong></span>Brands<br>` +
    //           `<span><strong>Category Name:</strong></span> ${pointWithMetric.name}<br>` +
    //           `<span><strong>Value:</strong></span> ${pointWithMetric.tooltip}`;
    //         return commonContent + '</div>';
    //       }
    //       else {
    //         const dotColor = pointWithMetric.actualcolor; // Get the series color
      
    //         const content =
    //           `<div style="background-color: ${backgroundcolor}; padding: 5px; align-items: center; border: 1px solid ${dotColor}; ">` +
    //           `<div style="width: 10px; height: 10px; background-color: ${dotColor}; border-radius: 50%; margin-right: 5px;"><div style="padding-left:10px;margin-top:0">${pointWithMetric.name}</div></div>`  +
    //           `<div style="display: block; margin-top: 5px;"><strong>Value:</strong> ${pointWithMetric.tooltip}</div>`;
      
    //         return content + '</div>';
      
    //       }
      
      
      
    //     },
    //  },
    //   plotOptions: {  
    //     pie: {
    //       innerSize: '100%',
    //       showInLegend: chartproperties.showLegend,
    //       borderWidth: 4,
    //       borderColor: null,
    //       slicedOffset: 10,
    //       shadow: chartproperties.shadow ? {
    //         color: chartproperties.darkTheme?'white':'rgba(0, 0, 0, 0.5)',
    //         offsetX: 1,
    //         offsetY: 1,
    //         opacity: 0.5,
    //         width: 6,
    //      } : false,
    //       dataLabels: {
    //         y:-5,
    //         style: {
    //           textOutline: 'none',
    //           fontSize: chartproperties.dataLabelSize,
    //           fontWeight:"normal"
    //         },
    //         enabled: chartproperties.showDataLabel,
    //         connectorWidth: chartproperties.connector?1:-1,
    //         connectorColor: null,
    //          color:chartproperties.dataLabelColor=="default"?(chartproperties.darkTheme?'white':'black'):chartproperties.dataLabelColor,
    //         connectorPadding: 0,
    //         distance: chartproperties.connector?30:0,
    //         useHtml: true,
    //         formatter: function (this: Highcharts.TooltipFormatterContextObject): any {
    //           const pointWithMetric = this.point as {
    //             name?:any;
    //             parent?:any;
    //             color?:any;
    //             y?: number;
    //             y1?:number;
    //             cov?: string;
    //             significance?: string;
    //             samplesize?: number;
    //             significance2?:any;
    //             tooltip?:any;
    //           };
    //           if (this.point.color !== '#eeebed' && this.color!='#7f7f7f') {
    //             let textcolor = chartproperties.darkTheme ? 'white' : 'black';
    //             if (chartproperties.datalabelStyle == 'datalabel') {
    //               let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat?'%':'') : 'NA';
    //               pointWithMetric.tooltip=text;
    //               return (
    //                 '<span style:"color:' + textcolor + ';">' + text + '</span>'
    //               );
    //             }
    //             if (chartproperties.datalabelStyle === 'change') {
    //               let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat?'%':'')+' ' + `<span span style="font-size: 80%;color:`+(chartproperties.darkTheme?'white':'black')+`">(`+(Number(pointWithMetric.cov)>0?'+':'')+`${pointWithMetric.cov} )</span>` : 'NA';
    //               pointWithMetric.tooltip=text;
    //               return (
    //                 '<span style:"color:' + textcolor + ';">' + text + '</span>'
    //               );
    //             }
    //              if (chartproperties.datalabelStyle === 'significance + changeVs') {
    //               const upwardTriangle = '\u25B2';
    //               const downwardTriangle = '\u25BC';
    //               let sig = Number(pointWithMetric.significance);
    //               let s =
    //                 sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
    //               let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
    //               let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat?'%':'')+' ' +  `<span span style="font-size: 80%;color:`+(chartproperties.darkTheme?'white':'black')+`">(`+(Number(pointWithMetric.cov)>0?'+':'')+`${pointWithMetric.cov} )</span>` +  '<span style="color:' +
    //               sigcolor +
    //               ';">' +
    //               s +
    //               '</span>' : 'NA';
    //               pointWithMetric.tooltip=text;
    //               return (
    //                 '<span style:"color:' +
    //                 textcolor +
    //                 ';">' +
    //                 text +
    //                '</span>'
    //               );
    //             }
    //             if (chartproperties.datalabelStyle == 'significance') {
    //               const upwardTriangle = '\u25B2';
    //               const downwardTriangle = '\u25BC';
    //               let sig = pointWithMetric.significance;
    //               let s =
    //               Number(sig) > 0 ? upwardTriangle : Number(sig )< 0 ? downwardTriangle : '';
    //             let sigcolor = Number(sig) > 0 ? 'green' : Number(sig) < 0 ? 'red' : '';
    //               let text = pointWithMetric.y1 != null ? (pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') +'<span style="color:' +sigcolor +';">' +s +'</span>'): 'NA';
    //               pointWithMetric.tooltip=text;
    //               return (
    //                 '<span style:"color:' +
    //                 textcolor +
    //                 ';">' +
    //                 text +
    //                 '</span>'
    //               );
    //             }
    //             if (chartproperties.datalabelStyle == 'ls') {
    //               let text = Number(pointWithMetric.samplesize)>samplesizeconstant?(pointWithMetric.y1 == null ? 'NA' : pointWithMetric.y + (chartproperties.dataLabelFormat?'%':'')):'LS';
    //               pointWithMetric.tooltip=text;
    //               return (
    //                 '<span style:"color:' + textcolor + ';">' + text + '</span>'
    //               );
    //             }
    //             if (chartproperties.datalabelStyle == "significance2") {
    //               const upwardTriangle = '\u25B2';
    //               const downwardTriangle = '\u25BC';
    //               let text = pointWithMetric.y1 != null ? this.y + (chartproperties.dataLabelFormat?'%':'') : 'NA';
    //               let changeText = pointWithMetric.cov;
    //               let sig = pointWithMetric.significance;
    //               let sig1 = pointWithMetric.significance2;
    //               let sColor = Number(sig) > 0 ? 'green' : (Number(sig) < 0 ? 'red' : '');
    //               let s = Number(sig) > 0 ? upwardTriangle : (Number(sig) < 0 ? downwardTriangle : '');
    //               let changeColor = sig1 < 0 ? 'red' : (sig1 > 0 ? 'green' : (chartproperties.darkTheme?'white':'black'));
  
    //               if (Number(changeText) > 0) {
    //                 changeText = "+" + changeText;
    //               }
    //               pointWithMetric.tooltip= '<span>' + text +
    //               (pointWithMetric.y1 != null && changeText ? '&nbsp<span style="color:' + ';"> ' +
    //                 '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span> &nbsp' +
    //                 '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
    //               '</span>';
    //               return (
    //                 '<span>' + text +
    //                 (pointWithMetric.y1 != null && changeText ? '&nbsp<span style="color:' + ';"> ' +
    //                   '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span> &nbsp' +
    //                   '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
    //                 '</span>'
    //               );
    //             }
    //           } else {
    //             return null;
    //           }
    //         },
    //       }

    //     }
    //   },
    //   series:this.seriesdata,
    //   credits: {
    //     enabled: false
    //   },
    //   exporting:{
    //     enabled:false
    //   }
    // } as any,
    // );

  }
  

  preparemainChartData(data: any) {
    this.chartMainData = [];
    // this.chartproperties=this.configuredProperties!=undefined?this.configuredProperties:this.chartproperties;
        
    if (this._configService.selectedSnapshotType.toLowerCase().includes('multi')) {

      data.metric_value.forEach((lev2: any) => {
        lev2.data.forEach((dataArr: any) => {
          let d1 = {
            "Series Name": dataArr.colChild.split("|").length>1?dataArr.colChild.split("|")[1]:dataArr.colChild,
            "Category Name": lev2.metric_group,
            "Rounded Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "ValueForIndex": (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "Label": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "Change value vs PY": dataArr.changeVsPY,
            "Significance": "-1",
            "Sample size": dataArr.baseValueforLSorIs,
            "Significance2": "1",
            "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? true : false,
            "Sig_LowerLimt": this.Sig_LowerLimt,
            "Sig_UpperLimt": this.Sig_UpperLimt,
            "Significance_Value": dataArr.Significance_Value,
            "color": dataArr.color,
            "colorLinearGradient": dataArr.colorLinearGradient
          }
          this.chartMainData.push(d1);
        })
      })
    }
    else {
      let i = 0;
      data.metric_value.forEach((lev2: any) => {
        lev2.data.forEach((dataArr: any) => {
          let d1 = {
            "Series Name": lev2.option,
            "Category Name": lev2.metric_group,
            "Rounded Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "ValueForIndex": (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "Label": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "Change value vs PY": dataArr.changeVsPY,
            "Significance": "-1",
            "Sample size": dataArr.baseValueforLSorIs,
            "Significance2": "1",
            "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? true : false,
            "Sig_LowerLimt": this.Sig_LowerLimt,
            "Sig_UpperLimt": this.Sig_UpperLimt,
            "Significance_Value": dataArr.Significance_Value,
            "color": dataArr.color,
            "colorLinearGradient": dataArr.colorLinearGradient
          }
          this.chartMainData.push(d1);
        });
      });
    }

  }

  // oncheckboxchecked(event: any, checkboxchecked: any) {
  //   this.piechartservice.commonfunction(
  //     event,
  //     checkboxchecked,
  //     this.chartproperties
  //   );
  //   this.plotChart('chart-container', this.jsondata['data'], this.chartproperties);
  // }

  userselectedproperties(){
    this.jsondata['data']=this.jsondata['data'].slice(0,this.datalength);
    this.jsondata['properties'][0]=this.chartproperties;
    return JSON.stringify(this.jsondata).toString();
  }


  private updateSigSub: Subscription | null = null;

  ngOnDestroy(): void {
    this.updateSigSub?.unsubscribe();
    this.subscriptions.unsubscribe();
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }
}





